//
//
//
//
//
//
//
//
//
//
//
//

import { removeEmptyValuesInObject } from '@core/helpers'
import { createObserver } from '@core/helpers/vue-Intersection-observer'
import { saveProductInfos } from '@tracking'
import { trackProductImpression } from '@tracking/events'

import { Card, CardPlaceholder } from './Card'
import { List, ListPlaceholder } from './List'

export const PRODUCT_DISPLAYS = {
  CARD: 'card',
  LIST: 'list',
}

export default {
  components: {
    Card,
    CardPlaceholder,
    List,
    ListPlaceholder,
  },
  props: {
    productId: {
      type: [String, Number],
      default: null,
    },
    link: {
      type: Object,
      default: () => {},
    },
    title: {
      type: String,
      default: '',
    },
    titleModel: {
      type: String,
      default: '',
    },
    subTitleModel: {
      type: Array,
      default: () => [],
    },
    brand: {
      type: String,
      default: '',
    },
    grade: {
      type: String,
      default: '',
    },
    warranty: {
      type: [String, Number],
      default: '',
    },
    thumbnail: {
      type: String,
      default: '',
    },
    attributes: {
      type: Array,
      default: () => [],
    },
    name: {
      type: String,
      default: '',
    },
    /**
     * Before Backmarket's price
     *
     * @typedef {object} price
     * @property {number} price.raw
     * @property {string} price.display
     */
    price: {
      type: Object,
      default: () => ({}),
    },
    /**
     * Before Backmarket's price
     *
     * @typedef {object} originalPrice
     * @property {number} originalPrice.raw
     * @property {string} originalPrice.display
     */
    originalPrice: {
      type: Object,
      default: () => ({}),
    },
    /**
     * Carriers Details
     *
     * @typedef {object} carriers
     * @property {Array} carriers.list
     * @property {Boolean} carriers.locked
     * @property {Boolean} carriers.showCarrier
     */
    carriers: {
      type: Object,
      default: () => ({}),
    },
    display: {
      type: String,
      default: PRODUCT_DISPLAYS.CARD,
      validator: (value) => Object.values(PRODUCT_DISPLAYS).includes(value),
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    sourceType: {
      type: String,
      default: '',
    },
    isRecommendation: {
      type: Boolean,
      default: false,
    },
    isVanishing: {
      type: Boolean,
      default: false,
    },
    stockRaw: {
      type: Number,
      default: 0,
    },
    pressureStockLimit: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return { unobserve: null }
  },

  computed: {
    hasVanishingTag() {
      return this.isRecommendation && this.isVanishing
    },
    cardComponent() {
      return this.isLoading ? CardPlaceholder : Card
    },
    listComponent() {
      return this.isLoading ? ListPlaceholder : List
    },
    productComponent() {
      switch (this.display) {
        case PRODUCT_DISPLAYS.CARD:
          return this.cardComponent
        case PRODUCT_DISPLAYS.LIST:
          return this.listComponent
        default:
          return null
      }
    },
    propsToBind() {
      const {
        link,
        attributes,
        name,
        title,
        titleModel,
        subTitleModel,
        thumbnail,
        price,
        originalPrice,
        warranty,
        grade,
        carriers,
        isRecommendation,
        isVanishing,
        stockRaw,
        pressureStockLimit,
      } = this.$props

      const cardProps = {
        link,
        name,
        title,
        titleModel,
        subTitleModel,
        thumbnail,
        price,
        originalPrice,
        warranty,
        grade,
        carriers,
        isRecommendation,
        isVanishing,
        stockRaw,
        pressureStockLimit,
      }

      // Remove empty props and bind right props to the right component to prevent polluting DOM
      if (this.display === PRODUCT_DISPLAYS.CARD) {
        return removeEmptyValuesInObject(cardProps)
      }
      if (this.display === PRODUCT_DISPLAYS.LIST) {
        return removeEmptyValuesInObject({
          ...cardProps,
          attributes,
        })
      }

      return {}
    },

    productTrackingInfos() {
      return {
        list: this.sourceType,
        brand: this.brand,
        variant: this.grade,
        stock: this.stockRaw,
        price: this.price.raw,
        id: this.productId,
        uuid: this.productId,
        warrantyDuration: this.warranty,
      }
    },
  },

  destroyed() {
    if (this.unobserve) {
      this.unobserve()
    }
  },

  mounted() {
    this.watchCardInViewport()
  },

  methods: {
    watchCardInViewport() {
      // Don't observe anything if the component is in a loading state.
      if (this.isLoading) {
        return
      }

      this.unobserve = createObserver(this.$el, () => {
        trackProductImpression(this.productTrackingInfos)
      })
    },

    storeItem() {
      saveProductInfos({
        id: this.productId,
        price: this.price.raw,
        source: this.sourceType,
      })
    },
  },
}
